import { CourseConfigType } from 'common/src/courseConfig'

export const getAbbreviationName = (
    courseConfigType: CourseConfigType
): string => {
    switch (courseConfigType) {
        case CourseConfigType.fsaHealth:
            return 'JEP'
        default:
            return 'JEP' // in case course config type is null for some reason
    }
}

export const getLongName = (courseConfigType: CourseConfigType): string => {
    switch (courseConfigType) {
        case CourseConfigType.fsaHealth:
            return 'Just Enough Prep'
        default:
            return 'Just Enough Prep' // in case course config type is null for some reason
    }
}
